import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class StateService {
private activeSectionSubject = new BehaviorSubject<string>('myMeds');
activeSection$ = this.activeSectionSubject.asObservable();

    setActiveSection(section: string) {
        this.activeSectionSubject.next(section);
    }
private worldpayActiveSubject = new BehaviorSubject<boolean>(false);
worldpayActive$ = this.worldpayActiveSubject.asObservable();

setWorldpayActive(isActive: boolean) {
this.worldpayActiveSubject.next(isActive);
}

// Dashboard counts shared across components
private dashboardCountsSubject = new BehaviorSubject<any>(null);
dashboardCounts$ = this.dashboardCountsSubject.asObservable();

setDashboardCounts(counts: any) {
    this.dashboardCountsSubject.next(counts);
    localStorage.setItem('DboardCounts', JSON.stringify(counts));
}
}
